import { mount } from 'svelte';
import App from './App.svelte';
// The design system first, so the app's own rules can build on its tokens.
import './design.css';
import './base.css';
import './app.css';

const target = document.getElementById('app');
if (!target) {
	throw new Error('the mount point #app is missing from index.html');
}

export default mount(App, { target });
